import { render, staticRenderFns } from "./RdmSidebarItem.vue?vue&type=template&id=da5e0078&scoped=true&"
import script from "./RdmSidebarItem.vue?vue&type=script&lang=ts&"
export * from "./RdmSidebarItem.vue?vue&type=script&lang=ts&"
import style0 from "./RdmSidebarItem.vue?vue&type=style&index=0&id=da5e0078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5e0078",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItem,VListItemIcon,VListItemTitle})
